class CustomSelect {
  constructor(element) {
    this.element = element;
    this.selected = element.querySelector(".v-product-option__selected");
    this.originalDropdown = element.querySelector(
      ".v-product-option__dropdown"
    );
    this.dropdownContent = null;
    this.isOpen = false;
    this.optionPosition = this.selected.dataset.initialText
      .toLowerCase()
      .trim();

    // Store initial text and value
    this.selected.dataset.initialText = this.selected.textContent.trim();
    this.selected.dataset.selectedValue = "";

    // Wrap the text content in a span
    this.selected.innerHTML = `<span>${this.selected.textContent.trim()}</span>`;

    this.init();
  }

  init() {
    this.selected.addEventListener("click", (e) => {
      e.stopPropagation();
      this.toggleDropdown();
    });

    document.addEventListener("click", (e) => {
      if (!this.element.contains(e.target)) {
        this.closeDropdown();
      }
    });

    // Listen for swatch clicks
    const productCard = this.element.closest(".m-product-card");
    if (productCard) {
      const swatches = productCard.querySelectorAll(
        ".m-product-option--node__label"
      );
      swatches.forEach((swatch) => {
        swatch.addEventListener("click", (e) => {
          if (this.optionPosition === "color") {
            const value = swatch.getAttribute("data-value");
            this.updateSelection(value, true);
          }
        });
      });
    }

    // Add form submit handler
    const form = this.element.closest("form");
    if (form) {
      // Clear variant ID on page load
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.value = "";
      }

      form.addEventListener("submit", (e) => {
        const variantInput = form.querySelector('input[name="id"]');
        if (!variantInput.value) {
          e.preventDefault();
          return false;
        }

        // Reset selections after a short delay to allow form submission
        setTimeout(() => {
          this.resetSelection();
        }, 100);
      });
    }
  }

  resetSelection() {
    this.selected.querySelector("span").textContent =
      this.selected.dataset.initialText;
    this.selected.dataset.selectedValue = "";

    const form = this.element.closest("form");
    if (form) {
      const submitBtn = form.querySelector(".v-quick-add__submit");
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.querySelector(".v-quick-add__submit-text").textContent =
          "SELECT OPTIONS";
      }
    }
  }

  updateSelection(value, fromSwatch = false) {
    this.selected.querySelector("span").textContent = value;
    this.selected.dataset.selectedValue = value;

    const form = this.element.closest("form");
    if (!form) return;

    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput || !variantInput.dataset.productVariants) return;

    const variants = JSON.parse(variantInput.dataset.productVariants);
    if (!variants.length) return;

    // Get all current selections
    const selects = form.querySelectorAll(".v-product-option__selected");
    const selectsArray = Array.from(selects);
    const selections = selectsArray.reduce((acc, select) => {
      const optionName = select.dataset.initialText.toLowerCase().trim();
      acc[optionName] =
        optionName !== this.optionPosition
          ? select.dataset.selectedValue || ""
          : value;
      return acc;
    }, {});

    // Find matching variant based on all selected options
    const selectedVariant = variants.find((variant) => {
      // For single option products
      if (!variant.option2) {
        return (
          variant.option1 === value ||
          variant.option1 === selections[this.optionPosition]
        );
      }

      // For multi-option products, check all selections match
      const optionMatches = selectsArray.every((select) => {
        const optionName = select.dataset.initialText.toLowerCase().trim();
        const optionValue = selections[optionName];
        const variantValue =
          variant[`option${selectsArray.indexOf(select) + 1}`];
        return optionValue === variantValue;
      });

      return optionMatches;
    });

    // Update variant ID and button state
    const submitBtn = form.querySelector(".v-quick-add__submit");

    // Check if all required options are selected
    const hasAllRequiredSelections = selectsArray.every(
      (select) => selections[select.dataset.initialText.toLowerCase().trim()]
    );

    if (selectedVariant && hasAllRequiredSelections) {
      variantInput.value = selectedVariant.id;
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.querySelector(".v-quick-add__submit-text").textContent =
          "ADD TO CART";
      }
    } else {
      variantInput.value = "";
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.querySelector(".v-quick-add__submit-text").textContent =
          "SELECT OPTIONS";
      }
    }
  }

  createDropdown() {
    const options = Array.from(
      this.originalDropdown.querySelectorAll(".v-product-option__option")
    ).map((opt) => ({
      value: opt.dataset.value,
      text: opt.textContent.trim(),
    }));

    const dropdown = document.createElement("div");
    dropdown.className = "custom-dropdown";

    options.forEach((option) => {
      const optionElement = document.createElement("div");
      optionElement.className = "custom-dropdown__option";
      optionElement.textContent = option.text;
      optionElement.dataset.value = option.value;

      optionElement.addEventListener("click", (e) => {
        e.stopPropagation();
        this.updateSelection(option.value);
        this.closeDropdown();
      });

      dropdown.appendChild(optionElement);
    });

    return dropdown;
  }

  toggleDropdown() {
    if (this.isOpen) {
      this.closeDropdown();
    } else {
      this.openDropdown();
    }
  }

  openDropdown() {
    // Remove any existing dropdowns first
    const existingDropdowns = this.element.querySelectorAll(".custom-dropdown");
    existingDropdowns.forEach((dropdown) => dropdown.remove());

    this.dropdownContent = this.createDropdown();
    this.element.appendChild(this.dropdownContent);

    const selectedRect = this.selected.getBoundingClientRect();
    this.dropdownContent.style.minWidth = `${selectedRect.width}px`;

    this.isOpen = true;
    this.element.classList.add("is-open");
  }

  closeDropdown() {
    if (this.dropdownContent) {
      this.dropdownContent.remove();
      this.dropdownContent = null;
    }
    this.isOpen = false;
    this.element.classList.remove("is-open");
  }
}

// Initialize custom selects
document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll(".v-product-option__custom-select")
    .forEach((select) => {
      new CustomSelect(select);
    });
});
